export const INITIAL_STATE = {
    leftLowerArm: 0,
    leftLowerLeg: 0,
    leftUpperArm: 0,
    leftUpperLeg: 0,
    rightLowerArm: 0,
    rightLowerLeg: 0,
    rightUpperArm: 0,
    rightUpperLeg: 0,
    torsoCylinder: 0,
    positionY: 1.1
};

export const TAKING_BALL = {
    leftLowerArm: 0.009744729926696394,
    leftLowerLeg: 0.8412950170047457,
    leftUpperArm: -1.6533558442294032,
    leftUpperLeg: -1.0989889861773703,
    rightLowerArm: 0,
    rightLowerLeg: 0.5641115879787284,
    rightUpperArm: 0,
    rightUpperLeg: 0.4255198734657206,
    torsoCylinder: 1.2570701605437709,
    positionY: 0.9
}

export const THROWING_1 = {
    leftLowerArm: -0.9603972716643625,
    leftLowerLeg: 0,
    leftUpperArm: -3.7815790201868626,
    leftUpperLeg: 0.4255198734657206,
    positionY: 1.1,
    rightLowerArm: 0,
    rightLowerLeg: 0,
    rightUpperArm: 0,
    rightUpperLeg: 0,
    torsoCylinder: 0,
}

export const THROWING_2 = {
    leftLowerArm: 0,
    leftLowerLeg: 0,
    leftUpperArm: -3.613129307264911,
    leftUpperLeg: 0.4255198734657206,
    positionY: 1.1,
    rightLowerArm: 0,
    rightLowerLeg: 0,
    rightUpperArm: 0,
    rightUpperLeg: 0,
    torsoCylinder: 0
}
